// Objective counts for the quests table's "Objectives" column.
//
// Fog of war is NOT applied here, on purpose. quests.js already strips
// `hidden` steps from every row before it reaches a non-DM, so a player's
// array arrives pre-filtered and a DM's arrives whole. Filtering again in
// this helper would apply the fog twice: a player would get a denominator
// counting only the steps that survived, which is what we want, but a DM
// would silently lose the hidden steps from their own total — and the
// count would then disagree with the list QuestSteps renders right beside
// it in the detail modal.
//
// Pure and free of React/DOM so tests/quest-progress.test.js can exercise it
// in Vitest's `node` environment. (parseSteps lives in QuestSteps.jsx, which
// imports MarkdownText and therefore react-markdown — not importable from a
// node-environment test.)

/** @returns {{done: number, total: number}} */
export function stepProgress(steps) {
  if (!Array.isArray(steps)) return { done: 0, total: 0 }
  return {
    // A malformed entry still counts toward the total — it occupies a slot in
    // the quest's objective list whether or not we can read its status.
    done: steps.filter((s) => s && s.status === 'done').length,
    total: steps.length,
  }
}

/** The cell string: "2 / 5", or an em dash when the quest has no objectives. */
export function formatStepProgress(steps) {
  const { done, total } = stepProgress(steps)
  return total === 0 ? '—' : `${done} / ${total}`
}
